var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { BaseOrganizationDto, BaseOrganizationPublicProfileDto } from "./organization.dtos";
import { UserType } from "./user.dtos";
import { IsEnum } from "class-validator";
export class ServiceProviderOrganizationPublicProfileDto extends BaseOrganizationPublicProfileDto {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], ServiceProviderOrganizationPublicProfileDto.prototype, "type", void 0);
export class ServiceProviderOrganizationDto extends BaseOrganizationDto {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], ServiceProviderOrganizationDto.prototype, "type", void 0);
export class CreateServiceProviderOrganizationInput extends PickType(ServiceProviderOrganizationDto, ["name"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.SERVICE_PROVIDER;
    }
}
__decorate([
    IsEnum(UserType)
], CreateServiceProviderOrganizationInput.prototype, "type", void 0);
export class UpdateServiceProviderOrganizationInput extends PartialType(PickType(ServiceProviderOrganizationDto, ["name"])) {
    constructor() {
        super(...arguments);
        this.type = UserType.SERVICE_PROVIDER;
    }
}
__decorate([
    IsEnum(UserType)
], UpdateServiceProviderOrganizationInput.prototype, "type", void 0);
export class UpdateServiceProviderOrganizationDetailsInput extends PartialType(OmitType(ServiceProviderOrganizationDto, ["id", "name", "onChainAddress", "adminEmail"])) {
    constructor(fields) {
        super();
        this.type = UserType.SERVICE_PROVIDER;
        Object.assign(this, fields);
    }
}
__decorate([
    IsEnum(UserType)
], UpdateServiceProviderOrganizationDetailsInput.prototype, "type", void 0);
